export default __webpack_public_path__ + "static/media/personplaceholder.93e53bb8.png";